import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';

export default class SlugField extends Component {
  validate = (value) => {
    const { field, isConstructorForm } = this.props;
    const { required } = field;
    let error;
    if (!isConstructorForm && required && !value) {
      error = 'This field is required';
    } else if (value && !/^[a-zA-Z0-9_-]*$/i.test(value)) {
      error = 'The Slug can only contain Alphabets, Numbers, Hyphens, and Underscores';
    }
    return error;
  };

  render() {
    const { field } = this.props;
    return (
      <>
        <Field
          type="slug"
          name={field.fieldName}
          className="form-control form-control-sm"
          validate={this.validate}
          placeholder={field.placeholder['en']}
          autoComplete="off"
          title={field.fieldTitle['en']}
        />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}
